import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "./RecoverPasswordForm.module.scss";
import googleIcon from "assets/icons/google-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { createNewUser } from "service/AdminService";
import { postRegisterUser } from "store/slices/AdminSlice";
import Notification from "utils/Notifications";
import eye from 'assets/icons/eye.png'
import hidden from 'assets/icons/hidden.png'
import { getUserInfo, postRecoverPassword, postRecoverPasswordCheckPin, postRecoverPasswordEndProgress } from "service/AuthService";
import { changePinCode, setUser } from "store/slices/UserSlice";
import tokenDecode from "utils/decode";

import { ScaleLoader } from "react-spinners";
import { Button } from "components";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import { getImage } from "service/BackgroundService";

import PinCode from "hooks/PinCode/PinCode";
import RecoverCode from "hooks/RecoverCode/RecoverCode";
import {
  checkPinCode,
} from "service/AuthService";
import {
  ChangePin,
  SendDevice,
  login,
} from "service/AuthService";
import { useNavigate } from "react-router-dom";


const RecoverPasswordForm = ({ setRecoverPassword, RecoverPin }) => {
  const { t } = useTranslation('common')
  const [loader, setLoader] = useState(false);
  const [pinWindow, setPinWindow] = useState(false);
  const [newPasswordWindow, setNewPasswordWindow] = useState(false);

  const [inn, setInn] = useState(null);
  const [password, setPassword] = useState(null);
  const [checkPassword, setCheckPassword] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [datainfo, setDataInfo] = useState(false);
  const [userPinCode, setUserPinCode] = useState();
  const [pinCode, setPinCode] = useState();
  const [recoverCode, setRecoverCode] = useState();
  const [userId, setUserId] = useState();
  const [device, setDevice] = useState("");

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    setDevice(userAgent);
  }, []);
  let socket = null;

  const sendMessage = (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
    } else {
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const dispatch = useDispatch();
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(String(email).toLowerCase());
  };
   const pinLogIn = async () => {
  localStorage.setItem("mute", false);

  if (String(pinCode).length === 4) {
    setLoader(true);

    try {
      const response = await checkPinCode(pinCode, userId);

      if (response.data.success) {
        setNotify({
          isOpen: true,
          message: t('auth.welcome'),
          type: "success",
        });

        const socket = new WebSocket("wss://sys.chu.kg/ws/online_status/");
        socket.onopen = () => {
          socket.send(JSON.stringify({ command: "connect", user_id: userId }));
          socket.close();
        };

        let response2 = await SendDevice(device);

        setUserId(datainfo.user);
        sendMessage({ user_id: userId });
        dispatch(setUser(datainfo));

        setTimeout(() => {
          window.location.href = `/home/`;
        }, 1000);

      } else {
        setNotify({
          isOpen: true,
          message: t('auth.wrong_pin'),
          type: "error",
          sound: "error",
        });
      }
    } catch (error) {
      setNotify({
        isOpen: true,
        message: t('common.server_error_retry'),
        type: "error",
        sound: "error",
      });
    } finally {
      setLoader(false);
    }

  } else {
    setNotify({
      isOpen: true,
      message: t('auth.enter_4_pin'),
      type: "warning",
    });
  }
};

  const createUserPin = async () => {

    if (String(pinCode)?.length < 4 || !pinCode) {
      setNotify({
        isOpen: true,
        message: t('auth.enter_pin_short'),
        type: "error",
        sound: "error",
      });
    } else if (String(pinCode).length === 4) {
      try {
        setLoader(true);

        let response = await ChangePin(pinCode);
        dispatch(
          changePinCode({
            pin: pinCode,
          })
        );
        setTimeout(() => {
          setNotify({
            isOpen: true,
            message: t('auth.pin_set'),
            type: "success",
            sound: "success",
          });
        }, 1000);

        setNotify({
          isOpen: true,
          message: t('auth.welcome'),
          type: "success",
          sound: "success",
        });
        setTimeout(async () => {


         
        
          let response2 = await SendDevice(device);

          setUserId(datainfo.user);
          sendMessage({ user_id: userId });
          dispatch(setUser(datainfo));
          setTimeout(() => {

            navigate(`/home/`);
          }, 2000);
        }, 1000);
      } catch (error) {
        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: "error",
          sound: "error",
        });
      }
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      inn === null
    ) {
      setNotify({
        isOpen: true,
        message: t('auth.enter_inn'),
        type: "warning",
        sound: "warning",
      });
    }
    else if (inn.length < 5) {
      setNotify({
        isOpen: true,
        message: t('auth.inn_too_short'),
        type: "warning",
        sound: "warning",
      });
    } else
      try {
        setLoader(true);
        // SECURITY (Wave 2A): убран бэкдор logintrash('free','free'). Recover-flow
        // должен работать без предварительной аутентификации; backend endpoint
        // /account/recoverpassword/ отвечает анонимам напрямую.
        // TODO: восстановить полный flow когда бэкенд получит публичный
        // /account/recoverpassword/ endpoint (см. отчёт Wave 2A).

        let response = await postRecoverPassword(
          inn
        );

        if (response?.data?.message) {
          if (response?.data?.status_log === 'ok') {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "success",
              sound: "success",
            });
            setPinWindow(true)
          }
          else {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "error",
              sound: "error",
            });
          }
        }


      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }
  };
  const handleSubmitCode = async (event) => {
    event.preventDefault();
    if (String(recoverCode)?.length < 6 || !recoverCode) {
      setNotify({
        isOpen: true,
        message: t('auth.enter_pin_short'),
        type: "error",
        sound: "error",
      });
    } else
      try {
        setLoader(true);
        // SECURITY (Wave 2A): убран бэкдор logintrash('free','free') —
        // подтверждение кода не требует предварительной авторизации.
        let response = await postRecoverPasswordCheckPin(
          recoverCode,
          inn
        );

        if (response?.data?.message) {
          if (response?.data?.status_log === 'ok') {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "success",
              sound: "success",
            });
            setPinWindow(false)
            setNewPasswordWindow(true)
          }
          else {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "error",
              sound: "error",
            });
          }
        }


      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }
  };
  const handleSubmitEndProgress = async (event) => {
    event.preventDefault();
    if (password === null) {
      setNotify({
        isOpen: true,
        message: t('auth.enter_new_password'),
        type: "error",
        sound: "error",
      });
    } else if (checkPassword !== password) {
      setNotify({
        isOpen: true,
        message: t('auth.passwords_no_match'),
        type: "warning",
        sound: "warning",
      });
    } else
      try {
        setLoader(true);
        // SECURITY (Wave 2A): убран бэкдор logintrash('free','free') —
        // финальный сброс пароля идёт публично и завершается обычным login().
        let response = await postRecoverPasswordEndProgress(
          password,
          inn
        );

        if (response?.data?.message) {
          if (response?.data?.status_log === 'ok') {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "success",
              sound: "success",
            });
            const delay = 1000; 
            setTimeout(() => {
              
              const signIn = async (event) => {
                localStorage.removeItem("task");
                localStorage.removeItem("user");
                let responseinfo = await login(inn, password);
             
                localStorage.setItem("token", responseinfo.data.access);
                const userId = tokenDecode(responseinfo.data.refresh);
      
                let userResponse =  await getUserInfo(userId);
                const data = { ...userResponse.data, token: responseinfo.data.access };
           
                setUserPinCode(data.pin);
                setDataInfo(data)
                setOpenModal(true);
                setUserId(userId);
            
            };
            signIn()
            }, delay);
          }
          else {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "error",
              sound: "error",
            });
          }
        }


      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }
  };
  const forSelect = useSelector((state) => state.order.position);

  const dataRector = [forSelect];
  const handleInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^\d]/g, '');

    setInn(value);

  };
  const [isError, setIsError] = useState(false);


  return (
    <>
      <div className={`${styles.container} unv-form-card`}>

        <h2 className={`${styles.login__title} unv-form-card__title`}>{t('auth.recover_password_title')}</h2>

        {pinWindow === false ? (
          newPasswordWindow === false ? (
            <>
              <h4 className={styles.login__untitle}>{t('auth.recover_password_inn_hint')}</h4>
              <form action="#">
                <div className={styles.user_details}>
                  <div className={styles.input_pox} style={{ width: '100%' }}>
                    <span className={styles.datails}>{t('auth.inn')}</span>
                    <input
                      type="number"
                      placeholder={t('auth.inn')}
                      value={inn}
                      onChange={handleInputChange}
                      required
                    />
                  </div>


                </div>

                {loader ? (
                  <ScaleLoader color="black" size={30} />
                ) : (
                  <div className={styles.button}>


                    <input
                      type="submit"
                      onClick={handleSubmit}
                      value={t('auth.get_code')}
                    />

                  </div>
                )}
              </form>

              <h4 className={styles.login__untitle} style={{ marginTop: "10px" }}>{t('auth.support_phone_hint')} <b>0777404312</b>.</h4>
            </>
          ) : (
            <>
              <h4 className={styles.login__untitle}>{t('auth.create_new_password_hint')}</h4>
              <form action="#">
                <div className={styles.user_details}>
                  <div className={styles.input_pox} style={{ width: '100%' }}>

                    <input
                      type="text"
                      placeholder={t('auth.inn')}
                      value={inn}
                      readOnly={true}
                    />
                  </div>
                  <div className={styles.input_pox}>
                    <span className={styles.datails}>{t('auth.new_password')}</span>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder={t('auth.password')}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      className={styles.input__withIcon}
                    />
                    <button
                      type="button"
                      className={styles.show__password}
                      onClick={togglePasswordVisibility}
                      aria-label={
                        showPassword
                          ? t('auth.hide_password', 'Скрыть пароль')
                          : t('auth.show_password', 'Показать пароль')
                      }
                    >
                      <img src={showPassword ? hidden : eye} alt="" />
                    </button>
                  </div>
            <div className={styles.input_pox}>

              <span className={styles.datails}>{t('auth.repeat_password')}</span>
              <input
                type={showPassword ? "text" : "password"}
                placeholder={t('auth.password')}
                value={checkPassword}
                onChange={(e) => setCheckPassword(e.target.value)}
                required
              />

            </div>
                  <div style={{ width: '100%', paddingBottom: "20px" }}>

                  </div>
                </div>

                {loader ? (
                  <ScaleLoader color="black" size={30} />
                ) : (
                  <div className={styles.button}>


                    <input
                      type="submit"
                      onClick={handleSubmitEndProgress}
                      value={t('auth.signin')}
                    />

                  </div>
                )}
              </form>
            </>
          )
        ) : (

          <>
            <h4 className={styles.login__untitle}>{t('auth.enter_code_email')}</h4>
            <form action="#">
              <div className={styles.user_details}>
                <div className={styles.input_pox} style={{ width: '100%' }}>

                  <input
                    type="number"
                    placeholder={t('auth.inn')}
                    value={inn}
                    readOnly={true}
                  />
                </div>
                <div style={{ width: '100%', paddingBottom: "20px" }}>
                  <RecoverCode setRecoverCode={setRecoverCode} passwordVisible={false} />
                </div>
              </div>

              {loader ? (
                <ScaleLoader color="black" size={30} />
              ) : (
                <div className={styles.button}>


                  <input
                    type="submit"
                    onClick={handleSubmitCode}
                    value={t('auth.send_btn')}
                  />

                </div>
              )}
            </form>
          </>

        )}
        <hr className={styles.hr__line}></hr>

        <div className={styles.register_footer}>
          {t('auth.remember_password')}

          <button
            className={styles.register_button}
            onClick={() => setRecoverPassword(false)}
          >
            {t('auth.signin')}
          </button>


        </div>
      </div>

      <Notification notify={notify} setNotify={setNotify} />
      {!userPinCode ? (
        <>
          <ModalWindow
            openModal={openModal}
            setOpenModal={setOpenModal}
            modalTitle={
              <>
                <p>
                  {t('auth.welcome')}
                </p>
              </>
            }
            modalText={t('auth.create_pin')}
            width={"unset"}
          >
            <PinCode setPinCode={setPinCode} passwordVisible={false} />

            {loader ? (
              <Button
                style={{ width: "unset", border: "none", background: "none" }}
              >
                <ScaleLoader color="black" size={15} />
              </Button>
            ) : (
              <>
                <Button
                  onClick={() => setOpenModal(false)}
                  className={styles.btn_pin_close}
                >
                  {t('common.close')}
                </Button>
                <Button
                  style={{ width: "unset" }}
                  onClick={createUserPin}
                  className={styles.btn_pin}
                >
                  {t('common.save')}
                </Button>
              </>
            )}
          </ModalWindow>{" "}
        </>
      ) : (
        <ModalWindow
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalText={t('auth.enterPin')}
          width={"unset"}
        >
          <>
            <PinCode setPinCode={setPinCode} passwordVisible={false} />
            <Button
              onClick={() => setOpenModal(false)}
              className={styles.btn_pin_close}
            >
              {" "}
              {t('common.close')}
            </Button>
            <Button onClick={pinLogIn} className={styles.btn_pin}>
              {t('auth.signin')}
            </Button>
          </>
          <div className={styles.div_register_button} style={{marginTop:'5px'}}>
          <p
              className={styles.register_button_reset}
              onClick={() => RecoverPin()}
              style={{ margin: "0px 10px 0px 0" }}
            >
              {t('auth.forgot_pin')}

            </p>
      </div>
        </ModalWindow>
      )}
    </>
  );
};

export default RecoverPasswordForm;
